import React, { useEffect } from "react"
import ResponsiveLayout from "../../ProjectNonSpecificComponents/Layouts/ResponsiveLayout"
import AdminTemplateLeftPanel from "../Templates/AdminTemplate/AdminTemplateLeftPanel"
import MobileSaveButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/MobileSaveButton"
import Overlay from "components/ProjectNonSpecificComponents/Elements/Overlay/Overlay"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { observer } from "mobx-react"
import { PTKM_FORM_IDS } from "../Constants/ADMIN_PANEL_CONSTANTS"
import { Redirect } from "react-router"
import ROUTES from "../Constants/ROUTES"
import { ConfigContainer } from "./FormConfigurationPage"
import { usePTKMStore } from "../Contexts/PTKMStoreContext"
import DeadlinesFormSection from "../Elements/AdminForm/organisms/PtkmSections/DeadlinesFormSection"
import StatusFormSection from "../Elements/AdminForm/organisms/PtkmSections/StatusFormSection"
import RLAKRFormSection from "../Elements/AdminForm/organisms/PtkmSections/ResultFormSection"
import ActivatePTKMSection from "../Elements/AdminForm/organisms/PtkmSections/ActivatePTKMSection"
import AppRequests from "../API/AppRequests/AppRequests"
import { IMainField } from "../Interfaces/DataInterface"
import { useTranslation } from "react-i18next"
import useBrowserBtn from "components/ProjectNonSpecificComponents/Hooks/useBrowserBtn"
import { useHistory } from "react-router-dom"

export const PTKMFormConfigurationPage = observer(() => {
	const store = useStore()
	const ptkmStore = usePTKMStore()
	const { isMobile } = useScreenType()
	const { t } = useTranslation()
	const history = useHistory()

	//If connection failed or no config is selected return to config table
	if (!ptkmStore.ptkmConfig.id || !store.hasConnectionBeenMade) {
		return <Redirect to={ROUTES.PTKM} />
	}
	useEffect(() => {
		const getFields = async () => {
			const itemId = JSON.parse(ptkmStore.ptkmConfig.item).value

			if (!itemId) return []

			const { ok, data } = await AppRequests("ItemType").get<IMainField[]>("fields", {
				requestedItemId: itemId,
			})

			ptkmStore.setFields(data ?? [])
		}
		getFields()
	}, [ptkmStore.ptkmConfig.item])

	const _onBackBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		store.setInfoModalConfig({
			type: "warning",
			titleKey: "",
			descriptionKey: t("rawText.save-all-changes"),
			proceedTextKey: t("rawText.back"),
			onProceed: () => {
				ptkmStore.updateConfigBeforeUpdate()
				store.resetInfoModalConfig()
			},
		})
	}

	useBrowserBtn(
		!ptkmStore.checkIfFormIsEdited(),
		_onBackBtnClick,
		[ptkmStore.ptkmConfig],
		ROUTES.PTKM
	)

	return (
		<>
			<ResponsiveLayout
				leftPanel={<AdminTemplateLeftPanel type="PTKM" />}
				tabletSidebar={<AdminTemplateLeftPanel type="PTKM" />}
			>
				<ConfigContainer id="section-container">
					<DeadlinesFormSection id={PTKM_FORM_IDS.deadlines} />
					<StatusFormSection id={PTKM_FORM_IDS.statuses} />
					<RLAKRFormSection id={PTKM_FORM_IDS.rlakr} />
					<ActivatePTKMSection id={PTKM_FORM_IDS.active} />
				</ConfigContainer>
			</ResponsiveLayout>
			{isMobile && (
				<Overlay bottom={16} right={16}>
					<MobileSaveButton />
				</Overlay>
			)}
		</>
	)
})

export default PTKMFormConfigurationPage
